import React from 'react'
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'
import { ZIndexes } from '../../types/constants'

const LOADER_VARIANTS = ['padded'] as const

export default function BlueDotLoader({
  variant,
}: {
  variant?: (typeof LOADER_VARIANTS)[number]
}) {
  const { classes, cx } = useStyles()

  return (
    <div
      className={cx(classes.container, {
        [classes.padded]: variant === LOADER_VARIANTS[0],
      })}
    >
      <span className={classes.loader}></span>
    </div>
  )
}

const formLoading = keyframes({
  from: { transform: 'translate(-50%, -50%) scale(1)' },
  to: { transform: 'translate(-50%, -50%) scale(2)' },
})

const containerFade = keyframes({
  from: { opacity: '0' },
  to: { opacity: '1' },
})

const formLoadingBg = keyframes({
  from: {
    transform: 'translate(-50%, -50%) scale(1)',
    boxShadow: '0 0 0 15px rgb(13 161 236 / 0.5)',
  },
  to: {
    transform: 'translate(-50%, -50%) scale(2)',
    boxShadow: '0 0 0 0 rgb(13 161 236 / 0.3)',
  },
})

const useStyles = makeStyles()((theme) => ({
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: 'rgb(255 255 255 / 0.7)',
    zIndex: ZIndexes.Loader,
  },
  padded: {
    left: '-10px',
    top: '-10px',
    width: 'calc(100% + 20px)',
    height: 'calc(100% + 20px)',
    borderRadius: '10px',
    animation: `${containerFade} .3s ease-in-out`,
  },
  loader: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%)',
    position: 'absolute',
    '&:before, &:after': {
      content: '""',
      width: '15px',
      height: '15px',
      top: '50%',
      left: '50%',
      borderRadius: '100%',
      position: 'absolute',
      display: 'block',
      animation: `${formLoading} 0.6s infinite alternate ease-in-out`,
      background: theme.palette.primary.main,
      transform: 'translate(-50%, -50%) scale(1)',
    },
    '&:before': {
      opacity: 0.3,
      animation: `${formLoadingBg} 0.6s infinite alternate ease-in-out`,
      animationDelay: '0.2s',
    },
    '&:after': { width: '10px', height: '10px' },
  },
}))
